import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { changePasswordAfterEmailVerification as changePasswordApi } from "services/apis/auth";

export const changePasswordAfterEmailVerification = createAsyncThunk(
  "auth/changePasswordAfterEmailVerification",
  async ({ email, password1, password2 }: any, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password1", password1);
      formData.append("password2", password2);
      const response = await changePasswordApi(formData);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

interface ChangePasswordAfterEmailVerificationState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: ChangePasswordAfterEmailVerificationState = {
  status: "idle",
  error: null,
};

const changePasswordAfterEmailVerificationSlice = createSlice({
  name: "changePasswordAfterEmailVerification",
  initialState,
  reducers: {
    resetChangePasswordStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changePasswordAfterEmailVerification.pending, (state) => {
        state.status = "loading";
      })
      .addCase(changePasswordAfterEmailVerification.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(changePasswordAfterEmailVerification.rejected, (state, action: any) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetChangePasswordStatus } = changePasswordAfterEmailVerificationSlice.actions;
export default changePasswordAfterEmailVerificationSlice.reducer;
